var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sleep } from './misc.js';
const DefaultQueryOptions = {
    interval: 1000,
    reCount: 0,
    maxCount: 5,
};
export const retryAsyncFunction = (fetch, options = JSON.parse(JSON.stringify(DefaultQueryOptions)), checkIsInvalidError) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield fetch();
    }
    catch (error) {
        if (checkIsInvalidError === null || checkIsInvalidError === void 0 ? void 0 : checkIsInvalidError(error))
            throw error;
        if (options.reCount >= options.maxCount)
            throw error;
        yield sleep(options.interval);
        return retryAsyncFunction(fetch, Object.assign(Object.assign({}, options), { reCount: ++options.reCount }));
    }
});
